import { toast } from "react-toastify";
import { formatCamelCaseReg, PERMISSION_SOME } from "../shared/sharedConstants";
import { useStoreWrapper } from "../store/store";
import { useNavigate } from "react-router-dom";

// @ts-ignore
export const checkIfPermitted = (keys, userFacilities, facilityId, match?) => {
  const facilityPermission = getFacilityPermissions(userFacilities, facilityId);

  if (!facilityPermission || facilityPermission.length === 0) return false;

  let { permissions } = facilityPermission[0];

  // reassign to eliminate object references
  let _permissions = [
    ...(permissions.accountAdminPermissions ?? []),
    ...(permissions.incidentAlertPermissions ?? []),
    ...(permissions.authenticationPermissions ?? []),
    ...(permissions.incidentManagementPermissions ?? []),
    ...(permissions.incidentReviewPermissions ?? []),
    ...(permissions.reportPermissions ?? []),
  ];

  _permissions = getTruePermissions(_permissions);

  if (_permissions.length === 0) return false;

  const result = match ?? PERMISSION_SOME;

  return result(keys, (permission_key: any) =>
    _permissions.find((p: any) => p.apiName === permission_key)
  );
};

// @ts-ignore
export const getFacilityPermissions = (userFacilities, facilityId) => {
  return userFacilities.filter(
    (facility: any) => facility.facilityId === facilityId
  );
};

// get only permissions that are true
export const getTruePermissions = (permissions: any) => {
  return permissions.filter((perm: any) => perm.permissionValue === true);
};

export function usePermission() {
  const _navigate = useNavigate();

  // get logged in user permissions
  const userFacilities = useStoreWrapper((state) => state.userFacilities ?? []);

  return {
    // @ts-ignore
    isPermitted: (keys, facilityId, match?) =>
      checkIfPermitted(
        Array.isArray(keys) ? keys : [keys],
        userFacilities,
        facilityId,
        match
      ) || false,
    userFacilities,
    // @ts-ignore
    navigate: (path, keys, facilityId, cb?, match?) => {
      if (checkIfPermitted(keys, userFacilities, facilityId, match)) {
        if (cb) cb();
        _navigate(path);
      } else {
        toast.error(`Not authorized to ${formatCamelCaseReg(keys[0])}.`);
      }
    },
  };
}
